import { revealLines, clipBox, clipLine } from './module/gsap.js'
import lenisScroll from './module/lenisScroll.js'
import menuMobile from './module/menuMobile.js'
import scrollMarkers from './module/scrollMarkers.js'
import isoLoop from './module/isoLoop.js'
import cookies from './module/cookies.js'
import darkModeOS from './module/darkModeOS.js'
import animations from './module/animations.js'
import preventZoom from './module/preventZoom.js'
import alertRotateDevice from './module/alertRotateDevice.js'
import customRellax from './module/customRellax.js';
import stickyTextSwap from './module/stickyTextSwap.js';
import shaderHover from './module/shader-hover.js'
import logoLetterScroll from './module/logoLetterScroll.js'

function functions(deviceData) {
  // console.log(deviceData);
  lenisScroll()
  menuMobile(deviceData)
  scrollMarkers(deviceData)
  darkModeOS(cookies)
  animations()
  preventZoom()
  alertRotateDevice(deviceData.isDesktop, deviceData.isBigTablet, deviceData.isMobile)
  customRellax()
  stickyTextSwap()
  revealLines()
  clipBox()
  clipLine()
  isoLoop()
  if (deviceData.isDesktop) shaderHover()
  logoLetterScroll()
  // accordion()
  // customSwiper()
  // modal()
  // lazyLoader()
  // filters()
  // contactForm()
  // if (deviceData.isDesktop === true) pointer()
}

export default functions
